"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlaReconciliationPrompt = GlaReconciliationPrompt;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var edit_classification_dialog_1 = require("../../../components/dialogs/edit-classification-dialog");
var building_area_1 = require("../../../features/apis/building-area");
var building_1 = require("../../../features/apis/building");
var hooks_1 = require("../../../store/hooks");
var fmt = function (n) {
    return n == null ? "—" : "".concat(n.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }), " m\u00B2");
};
function GlaReconciliationPrompt(_a) {
    var _this = this;
    var _b, _c;
    var buildingId = _a.buildingId;
    var _d = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _d.clientId, userId = _d.userId;
    var summaryResponse = (0, building_area_1.useFetchBuildingGlaSummaryQuery)({ clientId: clientId, buildingId: buildingId }, { skip: !clientId || !buildingId }).data;
    var buildingResponse = (0, building_1.useFetchBuildingQuery)(buildingId, { skip: !buildingId }).data;
    var updateBuilding = (0, building_1.useUpdateBuildingMutation)()[0];
    var summary = summaryResponse === null || summaryResponse === void 0 ? void 0 : summaryResponse.content;
    var assetName = (_c = (_b = buildingResponse === null || buildingResponse === void 0 ? void 0 : buildingResponse.content) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "";
    // The area total as it stood when this page loaded. Anything different means the user has
    // reconfigured areas in this session, which is what the prompt reacts to.
    var baselineRef = (0, react_3.useRef)(null);
    // Totals the user has already answered for — so declining does not re-ask on every refetch.
    var answeredRef = (0, react_3.useRef)(new Set());
    var _e = (0, react_3.useState)(false), isOpen = _e[0], setIsOpen = _e[1];
    var _f = (0, react_3.useState)(false), isClassificationOpen = _f[0], setIsClassificationOpen = _f[1];
    var _g = (0, react_3.useState)(false), isSaving = _g[0], setIsSaving = _g[1];
    (0, react_3.useEffect)(function () {
        if (!summary)
            return;
        if (baselineRef.current === null) {
            baselineRef.current = summary.areaTotalSqm;
            return;
        }
        if (summary.areaTotalSqm === baselineRef.current)
            return;
        if (answeredRef.current.has(summary.areaTotalSqm))
            return;
        // Nothing to reconcile against if no GLA has ever been captured on the asset.
        if (summary.buildingGla == null) {
            baselineRef.current = summary.areaTotalSqm;
            return;
        }
        setIsOpen(true);
    }, [summary]);
    var dismiss = function () {
        if (summary) {
            answeredRef.current.add(summary.areaTotalSqm);
            baselineRef.current = summary.areaTotalSqm;
        }
        setIsOpen(false);
    };
    var applyGla = function (classification) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!summary)
                        return [2 /*return*/];
                    setIsSaving(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateBuilding({
                            clientId: clientId,
                            _id: buildingId,
                            editClassification: classification.classification,
                            effectiveDate: classification.effectiveDate,
                            effectiveTime: classification.effectiveTime,
                            reason: classification.reason,
                            fieldClassifications: classification.fieldClassifications,
                            lastModifiedBy: userId,
                            gla: summary.areaTotalSqm,
                        }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "Asset GLA updated",
                            description: "".concat(assetName || "The asset", " now records ").concat(fmt(summary.areaTotalSqm), "."),
                            color: "success",
                        });
                        dismiss();
                    }
                    else {
                        (0, react_1.addToast)({ title: "Update failed", description: response.message || "Could not update the asset GLA.", color: "danger" });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    message = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _a === void 0 ? void 0 : _a.message) || "Could not update the asset GLA.";
                    (0, react_1.addToast)({ title: "Update failed", description: message, color: "danger" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (!summary || summary.buildingGla == null)
        return null;
    var delta = summary.areaTotalSqm - summary.buildingGla;
    var isIncrease = delta > 0;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: dismiss, disableAnimation: true, size: "lg", children: (0, jsx_runtime_1.jsxs)(react_1.ModalContent, { children: [(0, jsx_runtime_1.jsxs)(react_1.ModalHeader, { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:ruler-angular-linear", className: "text-xl text-primary" }), "Update the asset's GLA?"] }), (0, jsx_runtime_1.jsxs)(react_1.ModalBody, { className: "text-sm text-gray-700", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["The areas in this building have changed. They now total ", (0, jsx_runtime_1.jsx)("strong", { children: fmt(summary.areaTotalSqm) }), " across ", summary.areaCount, " ", "leasable area", summary.areaCount === 1 ? "" : "s", ", while the asset records ", (0, jsx_runtime_1.jsx)("strong", { children: fmt(summary.buildingGla) }), "."] }), (0, jsx_runtime_1.jsxs)("div", { className: "rounded-lg bg-gray-50 p-3 text-sm", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between py-0.5", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-gray-600", children: "Leasable areas now total" }), (0, jsx_runtime_1.jsx)("span", { className: "font-medium", children: fmt(summary.areaTotalSqm) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between py-0.5", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-gray-600", children: "Asset GLA currently records" }), (0, jsx_runtime_1.jsx)("span", { className: "font-medium", children: fmt(summary.buildingGla) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-1 flex justify-between border-t border-gray-200 pt-1.5", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-gray-600", children: "Difference" }), (0, jsx_runtime_1.jsxs)("span", { className: "font-medium ".concat(isIncrease ? "text-success-600" : "text-warning-600"), children: [isIncrease ? "+" : "", fmt(delta)] })] })] }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-gray-500", children: "Leaving it unchanged is fine \u2014 a split can legitimately leave the building with unallocated floor area. Updating records the change in the asset's history." })] }), (0, jsx_runtime_1.jsxs)(react_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: dismiss, children: "Leave GLA unchanged" }), (0, jsx_runtime_1.jsxs)(react_1.Button, { color: "primary", isLoading: isSaving, onPress: function () { return setIsClassificationOpen(true); }, children: ["Update to ", fmt(summary.areaTotalSqm)] })] })] }) }), (0, jsx_runtime_1.jsx)(edit_classification_dialog_1.EditClassificationDialog, { isOpen: isClassificationOpen, entityLabel: "Asset: ".concat(assetName), changes: [{ field: "gla", label: "GLA", group: "Basic", oldValue: summary.buildingGla, newValue: summary.areaTotalSqm }], onCancel: function () { return setIsClassificationOpen(false); }, onConfirm: function (classification) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsClassificationOpen(false);
                                return [4 /*yield*/, applyGla(classification)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } })] }));
}
